import Layout from "../components/layout/Layout";

export default function PageNotFound() {
    return (
        <Layout>
            Page not Found
        </Layout>

    )
}